import React from 'react';
import Paragraph from 'app_previous/elements/typography/paragraph';
import IconsChecked from 'src/app_previous/images/IconsChecked';
import IconsNotChecked from 'src/app_previous/images/IconsNotChecked';
import { CheckedItemContainer } from './Checked.item.styles';

interface CheckedItemProps {
  text?: string;
  checked: boolean;
  svgWidth?: string;
  checkWeight?: string;
  fontWeight?: 'light' | 'normal';
}

const CheckedItem = ({ text, checked, checkWeight, fontWeight }: CheckedItemProps): JSX.Element => {
  return (
    <CheckedItemContainer hasText={!!text}>
      {checked ? <IconsChecked checkWeight={checkWeight} /> : <IconsNotChecked checkWeight={checkWeight} />}
      {text && (
        <Paragraph
          text={text}
          size='1.5rem'
          sizeSubMd='1.1rem'
          weight={fontWeight ?? 'light'}
        />
      )}
    </CheckedItemContainer>
  );
};

export default CheckedItem;
